import { IconProps } from './IconProps';

export const WarningTriangle = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.42017 0.833269L13.7601 10.377C13.9116 10.6546 14 10.9198 14 11.1976C14 12.1317 13.3436 12.8638 12.3209 12.8638H1.65374C0.631196 12.8638 0 12.1317 0 11.1976C0 10.9198 0.0757388 10.6546 0.227229 10.3896L5.55454 0.833269C5.85751 0.277799 6.43822 0 6.99367 0C7.54912 0 8.10457 0.277799 8.42017 0.833269ZM5.94588 9.93512C5.94588 10.5158 6.42559 10.9828 6.99367 10.9828C7.56175 10.9828 8.04145 10.5158 8.04145 9.93512C8.04145 9.37965 7.57438 8.89993 6.99367 8.89993C6.43822 8.89993 5.94588 9.36698 5.94588 9.93512ZM6.14786 3.79987L6.24886 7.32194C6.26148 7.73857 6.56446 8.04145 6.99367 8.04145C7.42288 8.04145 7.72585 7.73857 7.73848 7.32194L7.83947 3.79987C7.8521 3.30748 7.51125 2.95406 6.99367 2.95406C6.47609 2.95406 6.13523 3.30748 6.14786 3.79987Z"
        fill={props.fill ?? '#000000'}
      />
    </svg>
  );
};

